import { createSlice } from "infrastructure/store/lib";
import { sliceMixin } from "infrastructure/store/reducers";
import initialState, { sliceToken } from "./state";
import { getManualBulkKYCsImportHistoryThunk } from "./thunks";
import type { KYCState } from "./types";
import {
    kycRequestLoading,
    kycRequestFulfilled,
    kycRequestRejected
} from "./reducers";

const slice = createSlice({
    name: sliceToken,
    initialState,
    reducers: sliceMixin<KYCState>(initialState),
    extraReducers: builder => {
        builder
            .addCase(getManualBulkKYCsImportHistoryThunk.pending, kycRequestLoading)
            .addCase(getManualBulkKYCsImportHistoryThunk.fulfilled, kycRequestFulfilled)
            .addCase(getManualBulkKYCsImportHistoryThunk.rejected, kycRequestRejected)
    }
});

export const {
    name,
    actions: {
        changeExportLoading,
        resetState
    }
} = slice;

export default slice.reducer;
